import axiosServices from '../../utils/axios';
import { error } from '../utils';

export async function updateCliente(formData: any) {
  const response = await axiosServices.post(`campaing-ancona/customer/update`, formData);
  const content = await response;
  if (content) {
    return Promise.resolve(content);
  } else {
    return () => error(content);
  }
}

export async function saveRequestFromUrl(formData: any) {
  const response = await axiosServices.post(`campaing-ancona/customer/save-request`, formData);
  const content = await response;
  if (content) {
    return Promise.resolve(content);
  } else {
    return () => error(content);
  }
}
